<template>
			<div class="content">

        <s-location buy title="증표 구입"/>

				<h4 class="sub_title02" >증표 구입 신청 완료</h4>

        <div id="printMe">
          <c증표구입완료 ref="buy_ok"/>
        </div>

        <div class="btn_group print">
          <div class="right">
            <router-link to="/buy/buy_list" class="btn gray01 ">구입 목록</router-link>
            <button type="button" class="btn gray01" @click="$htmlToPaper('printMe')">인쇄</button>
          </div>
        </div>
			</div> <!-- content : width=950px; -->
</template>

<script>
let ui
export default {
  components: {
    'c증표구입완료' : require('@/components/c증표구입완료.vue').default,
  },
  mounted() {
    this.$refs.buy_ok.load(this.$route.query)
  },
}
</script>
<style scoped>
  .tbl01 th:first-child { width:150px;}
</style>